import React from "react"
import styled from "styled-components"

const MainArea = styled.div`
display: flex;
flex-direction: row;
    @media(max-width: 600px){
        display: flex;
        flex-direction: column-reverse;
        flex-wrap: wrap;
    }
`

export default props => <MainArea>{props.children}</MainArea>


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/components/FooterActionsPOS/MainSection/index.jsx